<template>
  <div class="stock-kline-view">
    <StockKLine5Min :stock-code.sync="stockCode" />
  </div>
</template>

<script>
import StockKLine5Min from '@/components/kline/StockKLine5Min.vue'

export default {
  name: 'StockKLine5MinView',
  components: {
    StockKLine5Min
  },
  data() {
    return {
      stockCode: 'sz.002602'
    }
  },
  created() {
    if (this.$route.query.code) {
      this.stockCode = this.$route.query.code
    }
  }
}
</script>

<style scoped>
.stock-kline-view {
  padding: 20px;
  flex: 1;
}
</style>
